import styles from "../../../common/ulColumn/style.module.css";
import React from "react";


export const UlItemLink = ({ items }) => {
  return (
    <>
      <a download href={items.link}>
        <li className={styles.listItem}>
          {/*<img*/}
          {/*  src={"/asset/images/Path 80.png"}*/}
          {/*  width="20"*/}
          {/*  className="ml-4 ml-lg-1"*/}
          {/*  alt=""*/}
          {/*/>*/}
          <svg
            style={cloudStyle}
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-file-earmark-arrow-down-fill"
            viewBox="0 0 16 16"
          >
            <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm-1 4v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 11.293V7.5a.5.5 0 0 1 1 0z" />
          </svg>
          {items.item}
        </li>
      </a>
    </>
  );
};
const cloudStyle = {
  color: "#ff5f00",
  fontSize: "52px",
  width: "21px",
  height: "21px",
  marginLeft: "5px",
};
